import { render, staticRenderFns } from "./TopicCourse.vue?vue&type=template&id=71137a12&scoped=true&"
import script from "./TopicCourse.vue?vue&type=script&lang=js&"
export * from "./TopicCourse.vue?vue&type=script&lang=js&"
import style0 from "./TopicCourse.vue?vue&type=style&index=0&id=71137a12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71137a12",
  null
  
)

export default component.exports